fields:
  comment: "Opmerkingen (let op: wordt gedeeld met klant)"
labels:
  treatmentAtTime: "{startDate} om {startTime}"
messages:
  addNoShow:
    title: No-show registreren
    body: Hiermee geef je aan dat de klant niet is op komen dagen op deze afspraak.
  removeNoShow:
    title: No-show verwijderen
    body: Hiermee geef je aan dat de klant wel is op komen dagen op deze afspraak.
  detachCustomer:
    title: Deelnemer verwijderen uit afspraak
    body: Weet je zeker dat je {customerName} uit deze afspraak wilt verwijderen? De klant krijg hier ook een bevestiging van via de mail.
  attachCustomer:
    title: Deelnemer toevoegen
    body: Vul de gegevens in van de nieuwe deelnemer voor {treatmentName} op {date}.
